import styled from "@emotion/styled";

const StyledDashboard = styled.div`
  display: flex;
  min-height: calc(100vh - 140px);
  flex-direction: column;
`;

export { StyledDashboard };
